import { httpsCallable } from 'firebase/functions';
import { functions } from '../platform/firebase/clients';

export type HarborRunnerTokenStatus = 'active' | 'expired' | 'revoked';

export interface HarborRunnerToken {
  id: string;
  label: string;
  createdAt: string | null;
  expiresAt: string | null;
  revokedAt: string | null;
  lastFour: string | null;
  status: HarborRunnerTokenStatus;
  scopes: string[];
}

export interface AdminHarborRunnerToken extends HarborRunnerToken {
  ownerEmail: string | null;
}

export interface CreatedHarborRunnerToken {
  token: string;
  tokenId: string;
  label: string;
  scopes: string[];
  createdAt: string;
  expiresAt: string;
}

interface ListTokensResponse {
  tokens: HarborRunnerToken[];
}

export interface AdminHarborRunnerTokensPage {
  tokens: AdminHarborRunnerToken[];
  nextPageToken: string | null;
}

export async function listHarborRunnerTokens(): Promise<HarborRunnerToken[]> {
  const callable = httpsCallable<Record<string, never>, ListTokensResponse>(
    functions,
    'listHarborRunnerTokens',
  );
  const result = await callable({});
  return result.data.tokens;
}

export async function listAdminHarborRunnerTokens(
  pageToken?: string | null,
): Promise<AdminHarborRunnerTokensPage> {
  const callable = httpsCallable<{ pageToken?: string }, AdminHarborRunnerTokensPage>(
    functions,
    'listAdminHarborRunnerTokens',
  );
  const result = await callable(pageToken ? { pageToken } : {});
  return result.data;
}

export async function createHarborRunnerToken(
  label: string,
  expiresInDays: number,
): Promise<CreatedHarborRunnerToken> {
  const callable = httpsCallable<
    { label: string; expiresInDays: number },
    CreatedHarborRunnerToken
  >(functions, 'createHarborRunnerToken');
  const result = await callable({ label, expiresInDays });
  return result.data;
}

export async function revokeHarborRunnerToken(tokenId: string): Promise<void> {
  const callable = httpsCallable<{ tokenId: string }, { ok: true }>(
    functions,
    'revokeHarborRunnerToken',
  );
  await callable({ tokenId });
}
